import React, { useState } from "react";
import ReReSubject from "./ReReSubject";
import { StandardButton } from "../../common/GlobalElements/StandardButton";
import { tokens } from "../../../public/tokens";

function ReWriteExam(props) {
  const {
    formik,
    setparentSubjectReWriteLength,
    parentSubjectReWriteLength,
    reRegSubject,
  } = props;

  const [fields, setFields] = useState([{ subject: "" }]);

  function handleAdd() {
    const values = [...fields];
    values.push({ subject: "" });
    setFields(values);
    props.setparentSubjectReWriteLength(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    if (values.length > 1) {
      values.splice(i, 1);
      setFields(values);
      props.setparentSubjectReWriteLength(values);
    }
  }

  function handleSubjectChange(i, event) {
    const values = [...fields];
    values[i].subject = event.target.value;
    setFields(values);
    props.handleDisableField(values, "re-write");
    props.setparentSubjectReWriteLength(values);
  }

  return (
    <>
      {formik.values.subjectReWrite_.map((item, idx) => (
          <div className="row"  key={item}>
            <div className="col-sm-6 d-flex gap-2">
              <select
                className="form-control"
                name={`subjectReWrite_[${idx}].subject`}
                onChange={(e) => handleSubjectChange(idx, e)}
                onBlur={formik.handleBlur}
                key={idx}
                value={formik.values.subjectReWrite_[idx].subject}
                disabled={props.disable || formik.values.subjectReWrite_[idx].subject != ''}
              >
                <option value="">---</option>
                <ReReSubject reRegSubject={reRegSubject} selectedSubjects={fields} currentIndex={idx}/>
              </select>

              {formik.touched.subjectReWrite_ &&
              formik.errors.subjectReWrite_ &&
              formik.touched.subjectReWrite_[idx] &&
              formik.errors.subjectReWrite_[idx] &&
              formik.touched.subjectReWrite_[idx].subject &&
              formik.errors.subjectReWrite_[idx].subject ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {formik.errors.subjectReWrite_[idx].subject}
                </div>
              ) : null}
            <div className="col pl-0">
              <StandardButton variant="danger" isRounded onClick={() => handleRemove(idx)}>
                <i className="fal fa-trash-alt"></i>
              </StandardButton>
            </div>
            </div>
          </div>
      ))}
      {
          fields.length < reRegSubject.length &&
      <React.Fragment>
        <div className="form-group m-0">
          <StandardButton
            variant="theme"
            textOnly
            fontWeight={tokens.typography.fontWeights.regular}
            onClick={() => handleAdd()}
            type="button"
          >
            <i className="fal fa-plus"></i> Add additional line item
          </StandardButton>
        </div>
      </React.Fragment>
      }
    </>
  );
}

export default ReWriteExam;
